<template>
  <vs-row vs-justify="center" id="kiosks-box">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-xs="12"
    >
      <vs-card>
        <v-tour name="KiosksA" :steps="steps">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions" class="v-step__buttons">
                    <button @click="promptShow" class="v-step__button">
                      Next
                    </button>
                  </div>
                </template>
                <template v-if="tour.currentStep === 1">
                  <div slot="actions" class="v-step__buttons">
                    <button @click="goToEdit" class="v-step__button">
                      Next
                    </button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
        <vs-table
          @search="handleSearch"
          @sort="handleSort"
          v-model="selected"
          :total="totalItems"
          max-items="10"
          search
          :data="kiosks"
        >
          <div slot="header">
            <vs-button
              id="create-kiosks-button"
              icon="add"
              color="primary"
              @click="openCreateSlider"
              >{{ $t("Kiosk.AddKioskButton") }}</vs-button
            >

            <!---Show Sectet --->
            <vs-prompt
              color="success"
              :active.sync="createShowSecret"
              :title="$t('Kiosk.ShowSecretPrompt.Title')"
              :cancel-text="$t('Kiosk.ShowSecretPrompt.CancelButton')"
              buttonAccept="false"
            >
              <div>
                <div class="mb-4">
                  <h4 class="font-weight-light">
                    {{ $t("Kiosk.ShowSecretPrompt.Key") }}
                  </h4>
                  <h3 class="mt-2">{{ createKeyValue }}</h3>
                </div>
                <div class="mb-4">
                  <h4 class="font-weight-light">
                    {{ $t("Kiosk.ShowSecretPrompt.Secret") }}
                  </h4>
                  <h3 class="mt-2 mb-2">{{ createSecretValue }}</h3>
                  <span class="text-danger mt-2">{{
                    $t("Kiosk.ShowSecretPrompt.SecretSave")
                  }}</span>
                </div>

                <div class="mb-4">
                  <h4 class="font-weight-light">
                    {{ $t("Kiosk.ShowSecretPrompt.Token") }}
                  </h4>
                  <vs-input v-model="createTokenValue" disabled class="w-100" />
                  <span class="text-danger mt-2">{{
                    $t("Kiosk.ShowSecretPrompt.TokenSave")
                  }}</span>
                </div>
              </div>
            </vs-prompt>

            <!---Show Login request --->
            <vs-prompt
              color="success"
              :active.sync="sendLoginRequestShow"
              :title="$t('Kiosk.ShowSecretPrompt.TitleLogin')"
              :cancel-text="$t('Kiosk.ShowSecretPrompt.CancelButton')"
              @accept="sendLoginRequest"
              @close="reset"
              :accept-text="$t('Display.ShowSecretPrompt.SendButton')"
            >
              <div>
                <div class="mb-4">
                  <h4 class="font-weight-light mt-2">
                    {{ $t("Display.ShowSecretPrompt.DisplayCode") }}
                  </h4>
                  <vs-input
                    v-model="codeKiosk"
                    class="w-100 pl-4 pr-4 mt-4 center"
                  />
                </div>
              </div>
            </vs-prompt>

            <!---Show Login request Success --->
            <vs-prompt
              color="success"
              :active.sync="requestLoginSuccesShow"
              :title="$t('Kiosk.ShowSecretPrompt.TitleLogin')"
              :cancel-text="$t('Kiosk.ShowSecretPrompt.CancelButton')"
              buttonAccept="false"
              @close="reset"
            >
              <div>
                <div class="mb-4">
                  <h3 class="font-weight-light mt-4">
                    {{ $t("Display.ShowSecretPrompt.LoginSuccess") }}
                  </h3>
                </div>
              </div>
            </vs-prompt>
          </div>
          <template slot="thead">
            <vs-th sort-key="status">{{ $t("Kiosk.Table.Status") }}</vs-th>
            <vs-th sort-key="name">{{ $t("Kiosk.Table.Name") }}</vs-th>
            <vs-th sort-key="key">{{ $t("Kiosk.Table.Key") }}</vs-th>
            <vs-th sort-key="key">{{ $t("Kiosk.Table.LastConnection") }}</vs-th>
            <vs-th sort-key="created_at">{{
              $t("Kiosk.Table.CreatedAt")
            }}</vs-th>
            <vs-th>{{ $t("Kiosk.Table.Options") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].last_ping_status">
                <div class="d-flex align-items-center">
                  <span
                    v-if="data[indextr].last_ping_status == 0"
                    class="status-icon inactive"
                  ></span>
                  <span
                    v-if="data[indextr].last_ping_status == 1"
                    class="status-icon active"
                  ></span>
                  <span v-if="data[indextr].last_ping_status == 0"> </span>
                  <span v-if="data[indextr].last_ping_status == 1"> </span>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].name">
                <div class="d-flex align-items-center">
                  <h5 class="mb-0 font-12">{{ data[indextr].name }}</h5>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].key">
                <div class="d-flex align-items-center">
                  <span class="">{{ data[indextr].key }}</span>
                </div>
              </vs-td>
              <vs-td :data="data[indextr].last_ping_date_time">
                <div class="d-flex no-block align-items-center">
                  <div class>
                    <span class="">
                      {{
                        data[indextr].last_ping_date_time
                          ? (new Date().getTime() -
                              new Date(
                                data[indextr].last_ping_date_time
                              ).getTime()) /
                              3600000 <
                            24
                            ? Math.floor(
                                (new Date().getTime() -
                                  new Date(
                                    data[indextr].last_ping_date_time
                                  ).getTime()) /
                                  3600000
                              ).toString() + " hours ago"
                            : Math.floor(
                                (new Date().getTime() -
                                  new Date(
                                    data[indextr].last_ping_date_time
                                  ).getTime()) /
                                  (24 * 3600000)
                              ).toString() + " day(s) ago"
                          : "no connection yet "
                      }}
                    </span>
                  </div>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].created_at">
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-calendar-text mr-2 display-8"></i>
                  {{ formatDate(data[indextr].created_at) }}
                </div>
              </vs-td>

              <vs-td>
                <div class="btn-alignment">
                  <vs-button
                    radius
                    color="warning"
                    type="border"
                    icon="edit"
                    id="edit-kiosk-button"
                    @click="openEditSlider(data[indextr])"
                  ></vs-button>
                  <vs-button
                    class="btn-alignment"
                    radius
                    color="primary"
                    type="border"
                    icon="lock"
                    @click="resetSecret(data[indextr])"
                  ></vs-button>
                  <vs-button
                    radius
                    color="success"
                    type="border"
                    icon="refresh"
                    @click="sendRefreshRequest(data[indextr])"
                  ></vs-button>
                  <vs-button
                    radius
                    color="success"
                    type="border"
                    icon="cast"
                    @click="
                      sendLoginRequestShow = true;
                      kioskInfo = data[indextr];
                    "
                  ></vs-button>
                  <vs-button
                      radius
                      color="primary"
                      type="border"
                      @click="goToV1(data[indextr])"
                  >V1</vs-button>
                  <vs-button
                      radius
                      color="primary"
                      type="border"
                      @click="goToV2(data[indextr])"
                  >V2</vs-button>
                  <vs-button
                    radius
                    color="danger"
                    type="border"
                    icon="logout"
                    @click="sendLogoutRequest(data[indextr])"
                  ></vs-button>
                  <vs-button
                    radius
                    color="danger"
                    type="border"
                    icon="delete"
                    @click="deleteKiosk(data[indextr])"
                  ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-card>
    </vs-col>
    <CustomizerAddCustomer
      v-if="selectedEvent_bool"
      ref="AddCustomerCustomizerKioskUpdate"
      :editPromptData="editPromptData"
      :queues="queues"
      :themes="themes"
      :themesV2="themesV2"
      :displayConfigV2="displayConfigV2"
      :kioskUpdate="showUpdate"
      :kioskCreate="showCreate"
      :side-bar-title="sliderTitle"
      @refresh_kiosk="refresh_kiosk"
      @credentials="credentials"
    ></CustomizerAddCustomer>
  </vs-row>
</template>

<script>
import CustomizerAddCustomer from "../../layout/full/customizer/CustomizerAddCustomer";
import { kioskService, queueService } from "../../_services";
import router from "../../_helpers/router";
// moment

export default {
  name: "Services",
  data: () => ({
    title: "Services",
    selectedEvent_bool: false,
    sliderTitle: "",
    showUpdate: false,
    showCreate: false,
    activePrompt: false,
    createShowSecret: false,
    createSecretValue: "",
    createKeyValue: "",
    createTokenValue: "",
    codeKiosk: null,
    kioskInfo: {},
    sendLoginRequestShow: false,
    requestLoginSuccesShow: false,
    services: [],
    kiosks: [],
    industryServices: [],
    editPromptData: {
      multi_language: "",
      default_language: "",
      id: -1,
      name: "",
      photo: "",
      photoUrl: "",
      photoDelete: false,
      theme: "liberrex",
      status: 1,
      printTicket: 0,
      smsTicket: 0,
      ticket_style: "",
      allowBooking: 0,
      allowQueue: 1,
      allowMultipleServices: 1,
      allowQuantityServices: 0,
      allowTxtQte: 0,
      quantityText: `{"en": "", "fr": "", "ar": ""}`,
      imagePath: "",
      collectDetails: 0,
      queues: [],
      ip_address: "",
      mac_address: "",
      require_internal_id: 0,
      should_print: 0,
      show_keyboard: 0,
      loginRequired: 0,
      pseudo: 0,
      primary: "",
      secondary: "",
      success: "",
      danger: "",
      zoom: 100,
      info: "",
    },
    selected: {},
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    maxItems: 0,
    steps: [
      {
        target: "header div .vs-button-primary", // We're using document.querySelector() under the hood
        header: {
          title: "Get Started",
        },
        params: {
          placement: "right", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#edit-kiosk-button",
        params: {
          placement: "auto",
        },
      },
    ],
    themes: [
      { value: "liberrex", text: "Liberrex Default" },
      { value: "light", text: "Snowy" },
      { value: "dark", text: "Dracula" },
      { value: "orange", text: "Orangina" },
      { value: "terra", text: "Terra" },
      { value: "greena", text: "Greena" },
      { value: "lemon", text: "Lemon" },
    ],
    themesV2: [
    { value: "firstTheme", text: "firstTheme" },
      { value: "secondTheme", text: "secondTheme" },
      { value: "thirdTheme", text: "thirdTheme" },
      { value: "fourthTheme", text: "fourthTheme" },
      { value: "sixthTheme", text: "sixthTheme" },
      { value: "seventhTheme", text: "seventhTheme" },
      { value: "eighthTheme", text: "eighthTheme" },
    ],
    queues: [],
    config_v2: {
      theme: "firstTheme",
      primaryColor: "#244578",
      secondaryColor: "#F39800",
      textColor: "#FFFFFF",
      IdleTimeout: 600000,
      services: {
        background: null,
        titleColor: "#FFFFFF",
        serviceBackground: "#FFFFFF",
        serviceTextColor: "#244578",
        selectedServiceBackgroundColor: "#F39800",
        selectedServiceTextColor: "#FFFFFF",
        mainButtonBackground: "#E9E4E1",
        mainButtonTextColor: "#244578",
      },
      booking: {
        background: "#E9E4E1",
        titleColor: "#244578",
        subColor: "#B3B0AD",
        textColor: "#FFFFFF",
        calendarBackground: "#FFFFFF",
        calendarSlotBackground: "#244578",
        timeSlotBackground: "#F39800",
        calendarDayBackgroundColor: "#244578",
        calendarButtonBackground: "#F39800",
      },
      header: {
        showHeader: true,
        headerBackground: "#FFFFFF",
        logo: null,
        borderRadius: true,
      },
      printTicket: {
        textColor: "#244578",
        secondaryTextColor: "#F39800",
        backgroundImage: null,
        background: "#E9E4E1",
        anonButtonBackground: "#F39800",
        sendButtonTextColor: "#244578",
        printTicketTimeout: 2000,
      },
      numPad: {
        numBackground: "#FFFFFF",
        numPrimary: "#244578",
        numSecondary: "#F39800",
        anonymSendButtonBackground: "#244578",
        anonymSendButtonColor: "#FFFFFF",
        sendButtonBackground: "#E9E4E1",
        sendButtonColor: "#244578",
      },
      footer: {
        showFooter: true,
        footerBackground: "rgba(0, 0, 0, 0.35)",
      },
    },
    displayConfigV2: false,
  }),
  components: {
    CustomizerAddCustomer,
  },
  methods: {
    reset() {
      this.codeKiosk = "";
    },
    sendRefreshRequest(kiosk) {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: this.$t("Kiosk.Refresh"),
        text: this.$t("Kiosk.RefreshText", { name: kiosk.name }),
        acceptText: this.$t("Toasts.AcceptButton"),
        cancelText: this.$t("Toasts.CancelButton"),
        accept: function() {
          this.showLoading();
          kioskService
            .sendRefreshRequest(kiosk.id)
            .then(
              function(data) {
                this.notify(
                  this.$t("Toasts.Successful"),
                  this.$t("Display.ResetSecretPrompt.ToastSuccess"),
                  "success"
                );
              }.bind(this)
            )
            .catch(
              function() {
                this.notify(
                  this.$t("Toasts.Error"),
                  this.$t("Display.ResetSecretPrompt.ToastFail"),
                  "danger"
                );
              }.bind(this)
            )
            .finally(
              function() {
                this.hideLoading();
              }.bind(this)
            );
        }.bind(this),
      });
    },
    goToV1(kiosk) {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: this.$t("Kiosk.Redirect"),
        text: this.$t("Kiosk.RedirectTextToV1", { name: kiosk.name }),
        acceptText: this.$t("Toasts.AcceptButton"),
        cancelText: this.$t("Toasts.CancelButton"),
        accept: ()=> {
          this.showLoading();
          kioskService.goToV1(kiosk.id)
              .then(
                  ()=> {
                    this.notify(
                        this.$t("Toasts.Successful"),
                        this.$t("Display.ResetSecretPrompt.ToastSuccess"),
                        "success"
                    );
                  }
              ).catch(()=> {
                    this.notify(
                        this.$t("Toasts.Error"),
                        this.$t("Display.ResetSecretPrompt.ToastFail"),
                        "danger"
                    );
                  }
              ).finally(  ()=> {
                    this.hideLoading();
                  }
              );
        }
      });
    },
    goToV2(kiosk) {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: this.$t("Kiosk.Redirect"),
        text: this.$t("Kiosk.RedirectTextToV2", { name: kiosk.name }),
        acceptText: this.$t("Toasts.AcceptButton"),
        cancelText: this.$t("Toasts.CancelButton"),
        accept: ()=> {
          this.showLoading();
          kioskService.goToV2(kiosk.id)
              .then(
                  ()=> {
                    this.notify(
                        this.$t("Toasts.Successful"),
                        this.$t("Display.ResetSecretPrompt.ToastSuccess"),
                        "success"
                    );
                  }
              ).catch(()=> {
                this.notify(
                    this.$t("Toasts.Error"),
                    this.$t("Display.ResetSecretPrompt.ToastFail"),
                    "danger"
                );
              }
          ).finally(  ()=> {
                this.hideLoading();
              }
          );
        }
      });
    },
    sendLogoutRequest(kiosk) {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: this.$t("Kiosk.Logout"),
        text: this.$t("Kiosk.LogoutText", { name: kiosk.name }),
        acceptText: this.$t("Toasts.AcceptButton"),
        cancelText: this.$t("Toasts.CancelButton"),
        accept: function() {
          this.showLoading();
          kioskService
            .sendLogoutRequest(kiosk.id)
            .then(
              function(data) {
                this.notify(
                  this.$t("Toasts.Successful"),
                  this.$t("Display.ResetSecretPrompt.ToastSuccess"),
                  "success"
                );
              }.bind(this)
            )
            .catch(
              function() {
                this.notify(
                  this.$t("Toasts.Error"),
                  this.$t("Display.ResetSecretPrompt.ToastFail"),
                  "danger"
                );
              }.bind(this)
            )
            .finally(
              function() {
                this.hideLoading();
              }.bind(this)
            );
        }.bind(this),
      });
    },
    sendLoginRequest() {
      let payload = {
        code: this.codeKiosk,
      };
      this.showLoading();
      kioskService
        .sendLoginRequest(this.kioskInfo.id, payload)
        .then(
          function(res) {
            this.requestLoginSuccesShow = true;
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Display.ResetSecretPrompt.ToastSuccess"),
              "success"
            );
          }.bind(this)
        )
        .catch(
          function() {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Display.ResetSecretPrompt.ToastFail"),
              "danger"
            );
          }.bind(this)
        )
        .finally(
          function() {
            this.hideLoading();
            this.reset();
          }.bind(this)
        );
    },
    refresh_kiosk() {
      kioskService.getAll().then(
        function(data) {
          this.kiosks = data.kiosks.data;
          this.totalItems = data.kiosks.total;
          this.totalPages = data.kiosks.last_page;
          this.maxItems = data.kiosks.per_page;
        }.bind(this)
      );
    },
    credentials(data) {
      this.handleChangePage(this.currentPage);
      this.createKeyValue = data.key;
      this.createSecretValue = data.secret;
      this.createTokenValue = data.authToken;
      this.createShowSecret = true;
      this.notify(
        this.$t("Toasts.Successful"),
        this.$t("Kiosk.ResetSecretPrompt.ToastSuccess"),
        "success"
      );
    },
    openCreateSlider() {
      this.sliderTitle = this.$t("Kiosk.AddKioskPrompt.Title");
      this.selectedEvent_bool = true;
      this.showUpdate = false;
      this.showCreate = true;
      // wait until component loads
      let interval = setInterval(() => {
        const el = this.$refs.AddCustomerCustomizerKioskUpdate;
        if (el) {
          clearInterval(interval);
          this.$refs.AddCustomerCustomizerKioskUpdate.update_prop(
            this.displayConfig,
            "display_create"
          );
          this.$refs.AddCustomerCustomizerKioskUpdate.show();
        }
      }, 100);
    },
    openEditSlider(selected) {
      this.sliderTitle = this.$t("Kiosk.EditKioskPrompt.Title");
      this.selectedEvent_bool = true;
      this.showUpdate = true;
      this.showCreate = false;

      let kioskConfig = JSON.parse(selected.config);
      this.editPromptData.id = selected.id;
      this.editPromptData.name = selected.name;
      (this.editPromptData.queues = kioskConfig.queues
        .toString()
        .split(",")
        .map(Number)),
        (this.editPromptData.theme = kioskConfig.theme);
      this.editPromptData.queues = this.editPromptData.queues.filter((elem) => {
        return this.queues.some((ele) => {
          return ele.id === elem;
        });
      });
      this.editPromptData.zoom = kioskConfig.zoom ? kioskConfig.zoom : 100;
      this.editPromptData.primary = kioskConfig.primaryDark;
      this.editPromptData.info = kioskConfig.info;
      this.editPromptData.secondary = kioskConfig.primaryMedium;
      this.editPromptData.success = kioskConfig.primaryLight;
      this.editPromptData.danger = kioskConfig.secondary;
      (this.editPromptData.default_language = kioskConfig.default_language
        ? kioskConfig.default_language
        : "fr"),
        (this.editPromptData.multi_language =
          kioskConfig.multi_language && kioskConfig.multi_language == "false"
            ? false
            : true),
        (this.editPromptData.status = selected.status);
      this.editPromptData.allowBooking = selected.allow_booking;
      this.editPromptData.allowQueue = selected.allow_queue;
      this.editPromptData.allowMultipleServices = +kioskConfig.allow_multiple_services;
      this.editPromptData.allowQuantityServices = +kioskConfig.allow_quantity_services;
      this.editPromptData.allowTxtQte = +kioskConfig.allow_quantity_text;
      this.editPromptData.quantityText = kioskConfig.quantity_text
        ? kioskConfig.quantity_text
        : `{"en": "", "fr": "", "ar": ""}`;
      this.editPromptData.imagePath = kioskConfig.image_path;
      this.editPromptData.allowPrintWebsocket = +kioskConfig.allow_print_websocket;
      this.editPromptData.displayPhonenumberMessage = +kioskConfig.display_phonenumber_message;
      this.editPromptData.printTicket = selected.allow_print_ticket;
      this.editPromptData.smsTicket = selected.allow_sms_ticket;
      this.editPromptData.ticket_style = selected.ticket_style;
      this.editPromptData.collectDetails = selected.collect_details;
      this.editPromptData.should_print = selected.should_print;
      this.editPromptData.photoUrl = kioskConfig.photo ? kioskConfig.photo : "";
      this.editPromptData.loginRequired = selected.login_required;
      this.editPromptData.pseudo = selected.pseudo;
      if (selected.config_v2 == null || selected.config_v2 == "null") {
        this.displayConfigV2 = false;
        this.editPromptData.config_v2 = this.config_v2;
      } else {
        this.displayConfigV2 = true;
        this.editPromptData.config_v2 = JSON.parse(selected.config_v2);
      }

      // wait until component loads
      let interval = setInterval(() => {
        const el = this.$refs.AddCustomerCustomizerKioskUpdate;
        if (el) {
          clearInterval(interval);
          this.$refs.AddCustomerCustomizerKioskUpdate.update_prop(
            this.displayConfig,
            "display_create"
          );
          this.$refs.AddCustomerCustomizerKioskUpdate.show();
        }
      }, 100);
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#kiosks-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#kiosks-box > .con-vs-loading");
    },
    promptShow() {
      this.$tours["KiosksA"].stop();
      this.activePrompt = true;
      this.steps[0].content = this.$t("Customer.Prompt.Content");
      this.steps[0].target = ".vs-button-primary";
      this.steps[0].params.placement = "auto";
      setTimeout(() => this.$tours["KiosksB"].start(), 500);
    },
    promptShowNew() {
      this.$tours["KiosksB"].stop();
      this.activePrompt = false;
      setTimeout(() => this.$tours["KiosksA"].start(1), 500);
    },
    goToEdit() {
      router.push({ path: "/feedback?istour=on" });
    },
    close() {
      this.createShowSecret = false;
      this.createKeyValue = "";
      this.createSecretValue = "";
    },
    handleSearch(keyword) {
      if (keyword == "") {
        kioskService.getAll().then(
          function(data) {
            this.kiosks = data.kiosks.data;
            this.totalItems = data.kiosks.total;
            this.totalPages = data.kiosks.last_page;
            this.maxItems = data.kiosks.per_page;
          }.bind(this)
        );
      }
      kioskService.filter(keyword).then(
        function(data) {
          this.kiosks = data.kiosks.data;
          this.totalItems = data.kiosks.total;
        }.bind(this)
      );
    },
    handleChangePage(page) {
      kioskService.getPage(page).then(
        function(data) {
          this.kiosks = data.kiosks.data;
        }.bind(this)
      );
    },
    handleSort(key, active) {
      /* eslint-disable */
      console.log({ key, active });
    },
    formatDate: function(value) {
      let date = this.$moment(value).format("DD MMMM YYYY [at] HH:mm");
      return date;
    },
    resetSecret(kiosk) {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: this.$t("Kiosk.ResetSecretPrompt.Title"),
        text: this.$t("Kiosk.ResetSecretPrompt.Text", { name: kiosk.name }),
        acceptText: this.$t("Toasts.AcceptButton"),
        cancelText: this.$t("Toasts.CancelButton"),
        accept: function() {
          this.showLoading();
          kioskService
            .resetPassword(kiosk.id)
            .then(
              function(data) {
                this.handleChangePage(this.currentPage);
                this.createKeyValue = data.key;
                this.createSecretValue = data.secret;
                this.createTokenValue = data.auto_auth_token;
                this.createShowSecret = true;
                this.notify(
                  this.$t("Toasts.Successful"),
                  this.$t("Kiosk.ResetSecretPrompt.ToastSuccess"),
                  "success"
                );
              }.bind(this)
            )
            .catch(
              function() {
                this.notify(
                  this.$t("Toasts.Error"),
                  this.$t("Kiosk.ResetSecretPrompt.ToastFail"),
                  "danger"
                );
              }.bind(this)
            )
            .finally(
              function() {
                this.hideLoading();
              }.bind(this)
            );
        }.bind(this),
      });
    },
    deleteKiosk(kiosk) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Kiosk.DeleteKioskPrompt.Title"),
        text: this.$t("Kiosk.DeleteKioskPrompt.Text", { name: kiosk.name }),
        acceptText: this.$t("Toasts.AcceptButton"),
        cancelText: this.$t("Toasts.CancelButton"),
        accept: function() {
          this.showLoading();
          kioskService
            .delete(kiosk.id)
            .then(
              function(data) {
                this.handleChangePage(this.currentPage);
                this.notify(
                  this.$t("Toasts.Successful"),
                  this.$t("Kiosk.DeleteKioskPrompt.ToastSuccess"),
                  "success"
                );
              }.bind(this)
            )
            .catch(
              function() {
                this.notify(
                  this.$t("Toasts.Error"),
                  this.$t("Kiosk.DeleteKioskPrompt.ToastFail"),
                  "danger"
                );
              }.bind(this)
            )
            .finally(
              function() {
                this.hideLoading();
              }.bind(this)
            );
        }.bind(this),
      });
    },
  },
  computed: {},
  mounted() {
    kioskService.getAll().then(
      function(data) {
        this.kiosks = data.kiosks.data;
        this.totalItems = data.kiosks.total;
        this.totalPages = data.kiosks.last_page;
        this.maxItems = data.kiosks.per_page;
      }.bind(this)
    );

    queueService.getAllWithSummary().then(
      function(data) {
        this.queues = data.queues.map((obj) => {
          return obj.queue;
        });
      }.bind(this)
    );
    this.$t("Kiosk.Content").map(
      (content, index) => (this.steps[index].content = content)
    );
    this.$route.query.istour && localStorage.getItem("skipTour") != "true"
      ? this.$tours["KiosksA"].start()
      : "";
  },
};
</script>

<style scoped>
.status-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 5px;
}

.inactive {
  background-color: red;
}

.active {
  background-color: green;
}
</style>
